import { useState } from "react";
import Checkbox from "../../../ui/checkbox/Checkbox";
import styles from "../LoginStyles.module.css";

const ResetPasswordForm = ({
  newPassword,
  setNewPassword,
  newPasswordHasError,
  repeatNewPassword,
  setRepeatNewPassword,
  repeatNewPasswordHasError,
  newPasswordHandler,
}) => {
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showRepeatNewPassword, setShowRepeatNewPassword] = useState(false);

  return (
    <>
      <header>
        <h2>Reset your password</h2>
      </header>

      <ol>
        <strong>New Password:</strong>
        <br />
        <li>Must be between 8-15 characters. Is case sensitive.</li>
        <li>It must not contain space and the word "password".</li>
        <li>
          Must contain at least: one uppercase, one lowercase, one number and
          one special character
        </li>
      </ol>

      <div className={styles.inputView}>
        <label htmlFor="newPassword">New password</label>
        <div className={styles.flex}>
          <input
            type={showNewPassword ? "text" : "password"}
            id="newPassword"
            placeholder="Enter your New password"
            maxLength={15}
            required
            autoComplete="off"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value.trim())}
          />
          <Checkbox
            labelClassname={styles.checkboxLabel}
            inputClassname={styles.checkbox}
            label={"Show"}
            checked={showNewPassword}
            onChange={() => setShowNewPassword((prev) => !prev)}
          />
        </div>
        {newPasswordHasError && (
          <span className={styles.errorText}>
            Your password is invalid. Please read note above on password
            requirement
          </span>
        )}
      </div>

      <div className={styles.inputView}>
        <label htmlFor="repeatNewPassword">Repeat New password</label>
        <div className={styles.flex}>
          <input
            type={showRepeatNewPassword ? "text" : "password"}
            id="repeatNewPassword"
            placeholder="Repeat your New password"
            maxLength={15}
            required
            autoComplete="off"
            value={repeatNewPassword}
            onChange={(e) => setRepeatNewPassword(e.target.value.trim())}
          />
          <Checkbox
            labelClassname={styles.checkboxLabel}
            inputClassname={styles.checkbox}
            label={"Show"}
            checked={showRepeatNewPassword}
            onChange={() => setShowRepeatNewPassword((prev) => !prev)}
          />
        </div>
        {repeatNewPasswordHasError && (
          <span className={styles.errorText}>
            Your repeat password does not match the new password
          </span>
        )}
      </div>

      <button
        className={`${styles.bgGreen} ${styles.btnTBMargins}`}
        onClick={newPasswordHandler}
      >
        Submit
      </button>
    </>
  );
};

export default ResetPasswordForm;
